import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import AdvancedFilter from '../../Components/AdvancedFilter'
import AdvancedTable from '../../Components/AdvancedTable'
import NewAttractionCreateMapping from '../../Containers/Attraction/NewAttractionCreateMapping'
import AttractionActions from '../../Redux/AttractionRedux'
import DestinationActions from '../../Redux/DestinationRedux'
import Pagination from 'react-js-pagination'

class NewAttractionMapping extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedDestinationID: null,
      filter: {
        page: 1,
        provider: '',
        q: ''
      },
      activeModal: null,
      destinationArray: [],
      detail: {}
    }
    this.providerSelector = [
      { label: 'ALL', value: '' },
      { label: 'BMG', value: 'BMG' },
      { label: 'KLOOK', value: 'KLOOK' },
      { label: 'LOKET', value: 'LOKET' }
    ]
  }

  componentDidMount () {
    this.props.getDestination()
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.destination.data !== prevProps.destination.data) {
      this._populateDestination(this.props.destination.data)
    }
    if (this.state.selectedDestinationID !== prevState.selectedDestinationID) {
      this._fetchPlaceWithDestination(this.state.filter)
    }
  }

  _fetchPlaceWithDestination = (filter) => {
    let data = {
      destination: this.state.selectedDestinationID,
      ...filter
    }
    this.props.getPlacesV2Request(data)
  }

  _handleChangePage = (page) => {
    let filter = this.state.filter
    filter.page = page
    this.setState({ filter })
    this._fetchPlaceWithDestination(filter)
  }

  _populateDestination = (data) => {
    let destinationArray = this.state.destinationArray
    if (data) {
      data.map((item, i) => (
        destinationArray[i] = { label: item.name, value: item.id }
      ))
    }
    this.setState({ destinationArray })
  }

  _callback = (event) => {
    event && event.preventDefault()
    this._fetchPlaceWithDestination(this.state.filter)
  }

  _manipulateState = (props) => {
    this.setState({ filter: props })
  }

  _selectItem = (detail, activeModal) => {
    this.setState({ detail: detail })
    this._triggerModal(activeModal)
  }

  _triggerModal = (activeModal, actionType) => {
    this.setState({ activeModal })
    if (actionType) {
      setTimeout(() => {
        this._fetchPlaceWithDestination(this.state.filter)
      }, 500)
    }
  }

  _uponSelect = (event) => {
    event && event.preventDefault()
    let selectedDestinationID = event.target.value
    this.setState({ selectedDestinationID })
  }

  _deletePlace = (args) => {
    const data = {
      destination_id: this.state.selectedDestinationID,
      place_id: args.id,
      type: args.place_type
    }
    this.props.deletePlace(data)
    setTimeout(() => {
      this._triggerModal(null, true)
    }, 250)
  }

  render () {
    const { attraction } = this.props
    const { data } = attraction
    return (
      <section>
        <Header
          attraction={attraction}
          title='Attraction Mapping'
          _modal={(args) => this._triggerModal(args)}
        />
        <DestinationSelector
          destinationArray={this.state.destinationArray}
          _uponSelect={(args) => this._uponSelect(args)}
        />
        {
          this.state.selectedDestinationID !== null &&
          <AdvancedFilter
            filters={[
              {
                type: 'text',
                name: 'Search by Title',
                placeholder: 'Insert title ...',
                field: 'q'
              },
              {
                type: 'selector',
                name: 'Provider',
                field: 'provider',
                selectors: this.providerSelector
              }
            ]}
            manipulateState={(props) => this._manipulateState(props)}
            callback={(event) => this._callback(event)}
          />
        }
        {
          this.state.selectedDestinationID !== null &&
          <AdvancedTable
            colSpan={3}
            header={[
              { field: 'Title' },
              { field: 'Provider' },
              { field: 'Delete' }
            ]}
            body={
              data.data &&
              data.data.length > 0 &&
              data.data.map(item => ([
                { field: item.title },
                { field: item.provider },
                {
                  field: <button
                    className='btn btn-danger'
                    onClick={() => this._selectItem(item, 'deleteMapping')}
                  >
                    <i className='fa fa-trash' />
                  </button>
                }
              ]))
            }
          />
        }
        {
          data.meta !== undefined &&
          this.state.selectedDestinationID !== null &&
          <div className='text-center'>
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={data.meta.page || this.state.filter.page}
              itemsCountPerPage={10}
              totalItemsCount={data.meta.count}
              pageRangeDisplayed={5}
              onChange={this._handleChangePage}
            />
          </div>
        }
        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.activeModal === 'create-mapping'} onClose={() => this._triggerModal(null)}>
          <NewAttractionCreateMapping _close={() => this._triggerModal(null, true)} />
        </Modal>
        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.activeModal === 'deleteMapping'} onClose={() => this._triggerModal(null)}>
          <DeleteMapping detail={this.state.detail} _delete={(args) => this._deletePlace(args)} _close={() => this._triggerModal(null)} />
        </Modal>
      </section>
    )
  }
}

const Header = ({ attraction, title, _modal }) => (
  <section className='section'>
    <header className='title-block'>
      <div className='d-flex justify-content-between'>
        <h1 className='title'>
          { title }
          {
            (attraction.fetching || attraction.processing) &&
            <div className='badge badge-info ml-2'>Loading ...</div>
          }
        </h1>
        <button className='btn btn-primary ml-2' onClick={() => _modal('create-mapping')}><i className='fa fa-map' /> Create Mapping</button>
      </div>
    </header>
  </section>
)

const DestinationSelector = ({ destinationArray, _uponSelect }) => (
  <div className='title-block'>
    <div className='form-group row'>
      <div className='col-3'>
        <label className='control-label'>Destination</label>
      </div>
      <div className='col-9'>
        <select defaultValue='DEFAULT' className='form-control' onChange={(event) => _uponSelect(event)}>
          <option disabled value='DEFAULT'>- Please select a destination -</option>
          {
            destinationArray.map((item, i) => (
              <option key={i} value={item.value}>{item.label}</option>
            ))
          }
        </select>
      </div>
    </div>
  </div>
)

const DeleteMapping = ({ detail, _close, _delete }) => (
  <section className='section' style={{ width: '40vw' }}>
    <div className='title-block'>
      <h3 className='title'>Delete Mapping</h3>
    </div>
    <div>
      <p className='text-center'>
        Remove {detail.title} <strong>({detail.provider})</strong> from Destination?
      </p>
    </div>
    <div className='d-flex justify-content-center'>
      <button className='btn btn-lg btn-secondary mr-2' onClick={_close}>Close</button>
      <button className='btn btn-lg btn-danger' onClick={() => _delete(detail)}>Delete</button>
    </div>
  </section>
)

const stateToProps = (state) => ({
  destination: state.destination,
  attraction: state.attraction,
  preset: state.preset,
  setting: state.preset.setting
})

const dispatchToProps = (dispatch) => ({
  getDestination: () => dispatch(DestinationActions.destinationRequest()),
  getPlacesV2Request: (data) => dispatch(AttractionActions.getPlacesV2Request(data)),
  deletePlace: (data) => dispatch(DestinationActions.deletePlaceFromDestinationRequest(data))
})

export default connect(stateToProps, dispatchToProps)(NewAttractionMapping)



// WEBPACK FOOTER //
// ./src/Pages/Attraction/NewAttractionMapping.js